import { NftSelectionScopeProvider } from "@/app/collections/items/nft-selection-scope-provider"
import { NftPreview, NftPreviewSkeleton } from "@/app/nft/preview"
import { SDKNFTScope } from "@/app/sdk/anaconda-sdk-scope"
import type { NftSearchItem } from "@anaconda/core/nft/search/types"
import { ScopeProvider } from "bunshi/react"
import { memo } from "react"

export enum GridItemType {
  PLACEHOLDER = "placeholder",
  NFT = "nft",
}

export interface NftItem {
  type: GridItemType.NFT
  nft: NftSearchItem
}

export interface PlaceholderItem {
  type: GridItemType.PLACEHOLDER
}

export type GridItem = NftItem | PlaceholderItem

interface Props {
  item: GridItem
}

export const GridItem = memo(function GridItem(props: Props) {
  if (props.item.type === GridItemType.NFT)
    return (
      <ScopeProvider scope={SDKNFTScope} value={props.item.nft}>
        <NftSelectionScopeProvider nft={props.item.nft}>
          <NftPreview {...props.item.nft} />
        </NftSelectionScopeProvider>
      </ScopeProvider>
    )

  return <NftPreviewSkeleton />
})
